import { JobTableQuery } from 'modules/jobManager/types';
import client from './ApolloClient';
import { fetchJobsTableDataQuery } from './queries/jobs';

export const fetchJobsTableData = (variables: JobTableQuery) =>
  client.query({ query: fetchJobsTableDataQuery, variables });
